import { useMapStore } from "@/store/mapStore";

export type MapAccessMode = "editable" | "read-only" | "unknown";

export interface MapAccessState {
  mode: MapAccessMode;
  canEdit: boolean;
  reason: "writable" | "secret" | "missing-map" | "missing-secret" | "read-only";
}

export function getCurrentMapAccess(): MapAccessState {
  const { currentMap, currentSecret, maps } = useMapStore.getState();

  if (!currentMap) {
    return { mode: "unknown", canEdit: false, reason: "missing-map" };
  }

  if (currentMap.writable === true) {
    return { mode: "editable", canEdit: true, reason: "writable" };
  }

  const knownSecret = currentSecret ?? maps.find((m) => m.uuid === currentMap.uuid)?.modificationSecret ?? null;
  if (knownSecret) {
    return { mode: "editable", canEdit: true, reason: "secret" };
  }

  return {
    mode: "read-only",
    canEdit: false,
    reason: currentMap.public ? "read-only" : "missing-secret",
  };
}

export function ensureCanEditCurrentMap(actionLabel: string): boolean {
  const access = getCurrentMapAccess();
  if (access.canEdit) return true;

  console.warn(`[access] blocked ${actionLabel}: ${access.reason}`);
  return false;
}
